export const INVOICE_MAX_BYTES = 10 * 1024 * 1024;

export const INVOICE_ACCEPT = ".pdf,.jpg,.jpeg,.png,.webp";

const ALLOWED_TYPES = new Set([
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/webp",
]);

export function validateInvoiceFile(file: File): string | null {
  if (!ALLOWED_TYPES.has(file.type)) {
    return "Unsupported file type. Allowed: PDF, JPG, PNG, WebP.";
  }
  if (file.size > INVOICE_MAX_BYTES) {
    return "File is too large. Maximum size is 10 MB.";
  }
  return null;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
